import React, { useEffect, useState } from "react";

const SPLASH_MS = 1500;
const FADE_MS = 400;

/** Full-screen mobile splash: Ston factory art for exactly 1.5s, then fades out. */
export default function SplashScreen({ onDone }) {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const hold = setTimeout(() => setFading(true), SPLASH_MS);
    const done = setTimeout(() => onDone?.(), SPLASH_MS + FADE_MS);
    return () => {
      clearTimeout(hold);
      clearTimeout(done);
    };
  }, [onDone]);

  return (
    <div
      data-testid="mobile-splash-screen"
      className="fixed inset-0 z-[9999] bg-black"
      style={{
        opacity: fading ? 0 : 1,
        transition: `opacity ${FADE_MS}ms ease-out`,
        pointerEvents: fading ? "none" : "auto",
      }}
    >
      <img
        src="/brand/splash.webp"
        alt="Ston Link — Building Materials"
        className="w-full h-full"
        style={{ objectFit: "cover", objectPosition: "center" }}
      />
    </div>
  );
}
